import content from '../content.json';
import { getRoleFromJson } from './helpers';

export const roles = getRoleFromJson({...content});

